import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { InputSlots } from '../components/DigitKeypad';
import AdaptiveLetterKeypad from '../components/AdaptiveLetterKeypad';
import { normalizeTurkishLetters } from '../components/turkishLetterKeyboard';

// The exact letter boxes and familiar keypad used by numeric-entry tasks.
// The answer is never displayed unless the child explicitly requests help.
// No native mobile keyboard popup, remote TTS, OCR or handwriting capture.
export default function LetterSlotsInput({
  length, alphabet, value, onChange, onSubmit, disabled = false,
  hint = '', celebrating = false, disabledMessage = 'Önce sözcüğü dinle', targetKind = 'word',
}) {
  const letters = normalizeTurkishLetters(alphabet);
  const noun = targetKind === 'syllable' ? 'heceyi' : targetKind === 'letter' ? 'harfi' : 'sözcüğü';
  const allowed = new Set(letters);
  const add = letter => {
    if (!disabled && allowed.has(letter) && value.length < length) onChange(value + letter);
  };
  const remove = () => { if (!disabled && value.length) onChange(value.slice(0, -1)); };
  const submit = () => {
    if (!disabled && value.length === length) onSubmit(value);
  };
  useEffect(() => {
    const onKeyDown = event => {
      if (disabled || event.ctrlKey || event.metaKey || event.altKey
        || /INPUT|TEXTAREA|SELECT/.test(event.target?.tagName || '')
        || event.target?.isContentEditable) return;
      const letter = event.key.length === 1 ? event.key.toLocaleUpperCase('tr-TR') : '';
      if (allowed.has(letter)) { event.preventDefault(); add(letter); }
      else if (event.key === 'Backspace') { event.preventDefault(); remove(); }
      else if (event.key === 'Enter' && event.target?.tagName !== 'BUTTON') {
        event.preventDefault(); submit();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  });
  return <Box className={`dyw-letter-entry${letters.length > 4 ? ' dyw-letter-entry-dense' : ''}`} role="group" aria-label="Harflerle yazma alanı" aria-disabled={disabled || celebrating}>
    <Typography className="dyw-letter-prompt" component="p">
      {celebrating ? (targetKind === 'word' ? 'Sözcüğü tamamladın! 🎉' : 'Yazmayı tamamladın! 🎉') : disabled ? disabledMessage : `Duyduğun ${noun} harflerle yaz`}
    </Typography>
    <InputSlots length={length} value={value} hint={hint} slotLabel="harf" testId="letter-slot" />
    <Box className="dyw-letter-keyboard">
      <AdaptiveLetterKeypad alphabet={letters}
        disabled={disabled || celebrating} onLetter={add} onDelete={remove}
        onSubmit={submit} submitDisabled={value.length !== length}
        submitLabel="Yazdım" />
    </Box>
    {hint && !celebrating && <Typography className="dyw-letter-hint">Birlikte yazıyoruz. Harflere bakarak sırayla seçebilirsin.</Typography>}
  </Box>;
}
